
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { EmployeeRow } from "./EmployeeRow";
import { Employee } from "../types";

interface EmployeesListProps {
  employees: Employee[];
}

export const EmployeesList = ({ employees }: EmployeesListProps) => {
  return (
    <div className="space-y-8 p-6 bg-gradient-to-br from-[#F1F0FB] to-white rounded-lg">
      <div className="bg-white p-6 rounded-xl border border-[#E5DEFF] shadow-md overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Role</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {employees.map((employee) => (
              <EmployeeRow key={employee.id} employee={employee} />
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
